import { postRequest } from '../../shared/utils';

export const CommitHandler = async (props) => {
  const { editedRow, tableDetails, addedRow, userDetails, configSchema, deletedRow } = props;
  const timestamp = new Date().toISOString().substring(0, 19);
  const resultSet = { success: true, errors: [] };
  const editedRecord = getEditedRowLogic({ editedRow, userDetails, timestamp });
  const formattedNewRows = getAddedRowLogic({ addedRow, userDetails, timestamp });
  const inserObjArr = [...formattedNewRows.new];
  const deleteObjArr = deletedRow.map((item) => item.role_to_screen_grid_attribute_id);
  const updateObjArr = editedRecord.edit.map(({ id, access_level: accessLevel }) => ({
    where: { id: { _eq: id } },
    _set: { access_level: accessLevel, updated_by: userDetails.userId, update_date: timestamp },
  }));
  try {
    const resp = await postRequest('/api/tables', {
      screenGridId: tableDetails.id,
      tables: [
        {
          schema: configSchema,
          table: 'mbd_roles_to_screen_grid_attribute',
          pkey: tableDetails.mbdDataGrid.dataGridUniqueIdentifier,
          insertObjects: inserObjArr,
          deleteIds: deleteObjArr,
          updateObjects: updateObjArr,
        },
      ],
    });
    if (resp.errors) {
      resultSet.errors.push({
        message: `The Record could not be updated due to the following error: ${resp.errors[0]?.message || resp.errors.message}`,
      });
      resultSet.success = false;
    }
  } catch (error) {
    resultSet.errors.push({
      message: `The Record could not be updated due to the following error: ${error.message}`,
    });
    resultSet.success = false;
  }
  return resultSet;
};

const getEditedRowLogic = ({ editedRow, userDetails, timestamp }) => {
  return editedRow.reduce(
    (resp, item) => {
      if (item['access_level'] === 'U' || item['access_level'] === 'H') {
        const editedRow = {
          id: item.role_to_screen_grid_attribute_id,
          access_level: item['access_level'],
          updated_by: userDetails.userId,
          update_date: timestamp,
        };
        resp.edit.push(editedRow);
      }
      return resp;
    },
    { edit: [] },
  );
};

const getAddedRowLogic = ({ addedRow, userDetails, timestamp }) => {
  return addedRow.reduce(
    (resp, item) => {
      if (item['access_level'] === 'U' || item['access_level'] === 'H') {
        const newRecord = {
          role_id: item.role_id,
          screen_grid_attr_config_id: item.screen_grid_attr_config_id,
          access_level: item.access_level,
          insert_date: timestamp,
          created_by: userDetails.userId,
          updated_by: userDetails.userId,
          update_date: timestamp,
        };
        resp.new.push(newRecord);
      }
      return resp;
    },
    { new: [] },
  );
};
